"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _row = _interopRequireDefault(require("./row.styles"));

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  gap: 0,
  wrap: 'nowrap',
  justify: 'flex-start',
  align: 'flex-start'
};

const Row = ({
  children,
  gap,
  justify,
  align,
  wrap,
  css,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_row.default, {
    css: {
      flexWrap: wrap,
      $$rowGap: `calc(${gap} * $space$lg)`,
      marginLeft: `calc(${gap} * $space$lg / 2)`,
      marginRight: `calc(${gap} * $space$lg / 2)`,
      justifyContent: justify,
      alignItems: align,
      ...css
    },
    ...props,
    children: children
  });
};

Row.toString = () => '.nextui-row';

const MemoRow = /*#__PURE__*/_react.default.memo(Row);

var _default = (0, _withDefaults.default)(MemoRow, defaultProps);

exports.default = _default;
module.exports = exports.default;